import { render, staticRenderFns } from "./triton-master-home.vue?vue&type=template&id=19953d70&scoped=true&"
import script from "./triton-master-home.vue?vue&type=script&lang=js&"
export * from "./triton-master-home.vue?vue&type=script&lang=js&"
import style0 from "./triton-master-home.vue?vue&type=style&index=0&id=19953d70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19953d70",
  null
  
)

export default component.exports